module.exports = __webpack_public_path__ + "assets/img/F2.3fb418fe.png";